if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.sourcePassed = false;
        this.blockedElements = new Map();
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.handleClick = this.handleClick.bind(this);
        this.handleViewportChange = this.updateVisibility.bind(this);
      }

      connectedCallback() {
        this.sourceButton = document.getElementById(this.dataset.sourceButton);
        if (!this.sourceButton) return;

        this.hidden = false;
        this.addEventListener('click', this.handleClick);
        this.mobileQuery.addEventListener('change', this.handleViewportChange);

        this.sourceObserver = new IntersectionObserver(([entry]) => {
          this.sourcePassed = entry.boundingClientRect.bottom < 0;
          this.updateVisibility();
        });
        this.sourceObserver.observe(this.sourceButton);

        this.blockerObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => this.blockedElements.set(entry.target, entry.isIntersecting));
          this.updateVisibility();
        });
        document.querySelectorAll('#judgeme_product_reviews, footer').forEach((element) => {
          this.blockedElements.set(element, false);
          this.blockerObserver.observe(element);
        });

        this.sourceMutationObserver = new MutationObserver(() => this.updateVisibility());
        this.sourceMutationObserver.observe(this.sourceButton, {
          attributes: true,
          childList: true,
          subtree: true,
        });

        this.updateVisibility();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.mobileQuery.removeEventListener('change', this.handleViewportChange);
        this.sourceObserver?.disconnect();
        this.blockerObserver?.disconnect();
        this.sourceMutationObserver?.disconnect();
      }

      handleClick(event) {
        if (!event.target.closest('[data-sticky-atc-button]')) return;

        const sourceButton = document.getElementById(this.dataset.sourceButton);
        if (!sourceButton || sourceButton.disabled || sourceButton.getAttribute('aria-disabled') === 'true') return;
        sourceButton.click();
      }

      updateVisibility() {
        const isBlocked = Array.from(this.blockedElements.values()).some(Boolean);
        this.classList.toggle('is-blocked', isBlocked);
        this.classList.toggle('is-visible', this.mobileQuery.matches && this.sourcePassed);
      }
    }
  );
}
